import { Box, Typography } from "@mui/material"
import {
    LocalPharmacy as LocalPharmacyIcon,
    Medication as MedicationIcon,
    Biotech as BiotechIcon,
    Favorite as FavoriteIcon,
    Bloodtype as BloodtypeIcon,
    Healing as HealingIcon,
    Air as AirIcon,
    Psychology as PsychologyIcon,
    AccountTree as AccountTreeIcon,
    Restaurant as RestaurantIcon,
    MonitorHeart as MonitorHeartIcon,
    Tablet as TabletIcon,
    Vaccines as VaccinesIcon,
    LocalDrink as LocalDrinkIcon,
    Spa as SpaIcon,
    Opacity as OpacityIcon,
    Inventory as InventoryIcon,
} from "@mui/icons-material"

const ProductImagePlaceholder = ({ product, size = 60, variant = "category" }) => {
    const getCategoryIcon = (category) => {
        const iconMap = {
            Antibiotics: <BiotechIcon sx={{ fontSize: size * 0.5, color: "#059669" }} />,
            Cardiovascular: <FavoriteIcon sx={{ fontSize: size * 0.5, color: "#dc2626" }} />,
            Diabetes: <BloodtypeIcon sx={{ fontSize: size * 0.5, color: "#7c3aed" }} />,
            "Pain Relief": <HealingIcon sx={{ fontSize: size * 0.5, color: "#ea580c" }} />,
            Respiratory: <AirIcon sx={{ fontSize: size * 0.5, color: "#0284c7" }} />,
            "Mental Health": <PsychologyIcon sx={{ fontSize: size * 0.5, color: "#8b5cf6" }} />,
            Thyroid: <AccountTreeIcon sx={{ fontSize: size * 0.5, color: "#06b6d4" }} />,
            Gastrointestinal: <RestaurantIcon sx={{ fontSize: size * 0.5, color: "#65a30d" }} />,
            Cholesterol: <MonitorHeartIcon sx={{ fontSize: size * 0.5, color: "#e11d48" }} />,
        }

        return iconMap[category] || <LocalPharmacyIcon sx={{ fontSize: size * 0.5, color: "#6b7280" }} />
    }

    const getPackageIcon = (packageType) => {
        const iconMap = {
            Tablets: <TabletIcon sx={{ fontSize: size * 0.5, color: "#1976d2" }} />,
            Capsules: <MedicationIcon sx={{ fontSize: size * 0.5, color: "#1976d2" }} />,
            Inhaler: <AirIcon sx={{ fontSize: size * 0.5, color: "#1976d2" }} />,
            Injection: <VaccinesIcon sx={{ fontSize: size * 0.5, color: "#1976d2" }} />,
            Syrup: <LocalDrinkIcon sx={{ fontSize: size * 0.5, color: "#1976d2" }} />,
            Cream: <SpaIcon sx={{ fontSize: size * 0.5, color: "#1976d2" }} />,
            Drops: <OpacityIcon sx={{ fontSize: size * 0.5, color: "#1976d2" }} />,
        }

        return iconMap[packageType] || <InventoryIcon sx={{ fontSize: size * 0.5, color: "#1976d2" }} />
    }

    const renderPlaceholder = () => {
        switch (variant) {
            case "category":
                return (
                    <Box
                        sx={{
                            width: size,
                            height: size,
                            backgroundColor: "#f8fafc",
                            borderRadius: 2,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: "2px dashed #e2e8f0",
                        }}
                    >
                        {getCategoryIcon(product.category)}
                    </Box>
                )

            case "package":
                return (
                    <Box
                        sx={{
                            width: size,
                            height: size,
                            backgroundColor: "#e3f2fd",
                            borderRadius: 2,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        {getPackageIcon(product.packageType)}
                    </Box>
                )

            case "initial":
                return (
                    <Box
                        sx={{
                            width: size,
                            height: size,
                            backgroundColor: "primary.main",
                            borderRadius: 2,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <Typography variant="h4" color="white" fontWeight="bold" sx={{ fontSize: size * 0.4 }}>
                            {product.productName.charAt(0).toUpperCase()}
                        </Typography>
                    </Box>
                )

            default:
                return (
                    <Box
                        sx={{
                            width: size,
                            height: size,
                            backgroundColor: "#f3f4f6",
                            borderRadius: 2,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: "2px dashed #d1d5db",
                        }}
                    >
                        <LocalPharmacyIcon sx={{ fontSize: size * 0.5, color: "#6b7280" }} />
                    </Box>
                )
        }
    }

    return renderPlaceholder()
}

export default ProductImagePlaceholder
